// extracted by mini-css-extract-plugin
export default {"header":"header-o3GgNklxaAIDZ5TMYfXy"};